module.exports = __webpack_public_path__ + "img/DEPARTMENT_STORE.875c3948.png";